import { ArrowUpRight, Search, Megaphone, Tag, MonitorSmartphone, BellRing, Crosshair, Lightbulb } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { goToAudit } from "@/lib/scroll";

const REVIEW_ITEMS = [
  { icon: Search, title: "Your Google Presence", copy: "Can customers find you when they're ready to buy?" },
  { icon: Megaphone, title: "Your Meta Ad Opportunity", copy: "Who could we target on Facebook and Instagram?" },
  { icon: Tag, title: "Your Offer", copy: "Are you giving people a compelling reason to respond?" },
  { icon: MonitorSmartphone, title: "Your Website / Landing Page", copy: "Are visitors turning into leads?" },
  { icon: BellRing, title: "Your Follow-Up", copy: "What happens after a lead comes in?" },
  { icon: Crosshair, title: "Your Competition", copy: "What are competing businesses doing to acquire customers?" },
  { icon: Lightbulb, title: "Your Ad Opportunity", copy: "Where would we spend money first?" },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const AuditForm = () => (
  <section id="audit" className="relative py-12 sm:py-16">
    <div className="pointer-events-none absolute right-[-10%] top-0 h-[420px] w-[420px] rounded-full bg-purple-600/12 blur-[140px]" />
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Free Lead Generation Audit</Eyebrow>
        <h2 className="mt-5 max-w-4xl font-display text-4xl font-extrabold leading-[0.95] tracking-tighter text-white sm:text-5xl lg:text-6xl">
          Want More Customers?{" "}
          <span className="text-purple-500">Let's Find Out What's Stopping You.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-400 md:text-lg">
          We'll analyze your current marketing and show you where we believe
          your business can generate more leads, calls and customers.
        </p>
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {REVIEW_ITEMS.map((r, i) => (
          <Reveal key={r.title} delay={0.04 * i}>
            <div
              data-testid={`audit-review-${slug(r.title)}`}
              className="h-full rounded-2xl border border-[#272732] bg-[#121217] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-purple-500/50"
            >
              <r.icon className="h-6 w-6 text-purple-400" />
              <h3 className="mt-4 font-display text-lg font-extrabold uppercase tracking-wide text-white">
                {r.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-zinc-400">{r.copy}</p>
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.3}>
          <button
            type="button"
            data-testid="audit-section-cta"
            onClick={goToAudit}
            className="group flex h-full min-h-[180px] w-full flex-col items-center justify-center gap-3 rounded-2xl bg-purple-600 p-7 text-center transition-all duration-300 hover:-translate-y-1 hover:bg-purple-500"
          >
            <span className="font-display text-2xl font-extrabold uppercase tracking-tight text-white">
              Get My Free Lead Audit
            </span>
            <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-purple-200">
              Takes About 60 Seconds
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </span>
          </button>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <p className="mt-8 text-center text-xs font-medium text-zinc-500">
          Free. No obligation. No cookie-cutter PDF — we look at your actual
          business and show you what we'd do.
        </p>
      </Reveal>
    </div>
  </section>
);
